import { validateSecondLastName } from '../../../validations/secondLastName';

export const useSecondLastNameValidation = ({ userProfile, formActions }) => {
    const handleSecondLastNameValidation = () => {
        const { name, lastName, secondLastName, documentType } = userProfile;
        const isValidSecondLastName = validateSecondLastName({ name, lastName, secondLastName, documentType });

        formActions.setValidity('userProfile.secondLastName', { required: isValidSecondLastName });
    };

    return { handleSecondLastNameValidation };
};
